import State from './types'

const initialState: State = {
    historyItems: [],
}

export default initialState
